module.exports = __webpack_public_path__ + "86d516e68365b3b296380da445cd84bd.svg";